import { api } from '@ezugi/utils/http/httpRequest';

import {
  AUTHENTICATE_URL,
  CHANGE_LANGUAGE_URL,
} from '../../../endpoints';

type SearchParams = {
  language: string;
  operator_id: string;
  game_id: string;
  table_id: string;
  identifier: string;
  lo: string;
};

type ChangeLanguageResponse = {
  result: unknown;
};

export const changeLanguage = async (params: SearchParams) => {
  const { result } = await api.get<ChangeLanguageResponse>(
    `${CHANGE_LANGUAGE_URL}?${new URLSearchParams(params).toString()}`
  );
  return { result, code: params.language };
};

type AuthResponse = {
  result: unknown;
};

export const authenticate = (
  params: SearchParams & { token: string }
) => api.get<AuthResponse>(
  `${AUTHENTICATE_URL}?${new URLSearchParams(params).toString()}`
);
